import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { EnvironmentService } from '@methylium/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { DeviceApplicationStateResolverActions } from '../device-application-state/device-application-state.actions';
import { selectDeviceApplicationStateLoaded } from '../device-application-state/device-application-state.selector';

@Injectable({ providedIn: 'root' })
export class DeviceApplicationStateResolver implements Resolve<boolean> {
  constructor(
    private readonly store: Store,
    private readonly environmentService: EnvironmentService
  ) {}

  resolve(): Observable<boolean> {
    const isAppManagementEnabled = this.environmentService.environment.features.appmanagement.enabled;
    if (!isAppManagementEnabled) {
      return of(undefined);
    }

    return this.store.select(selectDeviceApplicationStateLoaded).pipe(
      tap((loaded) => {
        if (!loaded) {
          this.store.dispatch(DeviceApplicationStateResolverActions.deviceApplicationStatesRequested());
        }
      }),
      map(() => true),
      first()
    );
  }
}
